import {useMutation, useQueryClient} from "@tanstack/react-query";
import {AxiosError} from "axios";
import adminSettingRepository from "../../repository/AdminSettingRepository";


const useCreateDefaultAdminSetting = (defaultChatWorkflowId: string, defaultKeywordClusterWorkflowId: string) => {
    const queryClient = useQueryClient();

    return useMutation<undefined, AxiosError>({
        mutationKey: ["adminSetting", 'create'],
        mutationFn: async () => {
            try {
                const {data} = await adminSettingRepository.create(defaultChatWorkflowId, defaultKeywordClusterWorkflowId);
                return data.result;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async () => {
            await Promise.all([
                queryClient.invalidateQueries({ queryKey: ["workflows"] }),
                queryClient.invalidateQueries({ queryKey: ["adminSetting"] }),
            ])
        }
    })
};

export default useCreateDefaultAdminSetting;